var _defs, _path, _polygon, _polygon2, _path2, _polyline, _line, _path3, _path4, _line2, _path5, _path6, _line3, _path7, _polyline2, _polyline3, _polyline4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2b337;}.cls-2{fill:none;}.cls-2,.cls-3{stroke:#231f20;stroke-miterlimit:10;stroke-width:.75px;}.cls-3,.cls-4{fill:#2f3e4a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46,4.22C22.96,4.22,4.22,22.96,4.22,46s18.74,41.78,41.78,41.78,41.78-18.74,41.78-41.78S69.04,4.22,46,4.22M46,88.54c-23.46,0-42.54-19.09-42.54-42.54S22.54,3.46,46,3.46s42.54,19.09,42.54,42.54-19.09,42.54-42.54,42.54"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "44.43 32.25 47.52 32.32 46.73 34.37 45.05 34.37 44.2 32.44 44.43 32.25"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45 34.85 46.57 34.85 47.74 43.44 45.9 45.28 43.88 43.48 45 34.85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.63,51.49h-2.28c-1.4,0-2.53-1.13-2.53-2.54v-12.58c0-2.29,1.82-4.11,4.11-4.11h11.78c2.27,0,4.11,1.82,4.11,4.11v12.58c0,1.41-1.14,2.54-2.54,2.54h-2.26"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "51.34 38.08 50.62 68.25 41.03 68.25 40.32 38.08"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.83,
    y1: 52.44,
    x2: 45.83,
    y2: 68.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.58,25.11c0-2.63-2.13-4.75-4.75-4.75s-4.75,2.13-4.75,4.75,2.13,4.75,4.75,4.75,4.75-2.13,4.75-4.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.79,39.85l.3,12.63.37,15.77h9.03l.38-15.77.06-2.56.32-15.55h-10.81c-2.16,0-3.87,1.72-3.87,3.87v11.84c0,1.33,1.06,2.39,2.38,2.39h2.15"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30.97,
    y1: 53.37,
    x2: 30.97,
    y2: 68.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.44,27.64c0-2.47-2-4.47-4.47-4.47s-4.47,2-4.47,4.47,2,4.47,4.47,4.47,4.47-2,4.47-4.47Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.57,52.47h2.15c1.32,0,2.38-1.07,2.38-2.39v-11.84c0-2.16-1.72-3.87-3.87-3.87h-10.81l.32,15.55.06,2.56.38,15.77h9.03l.37-15.77.3-12.63"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.68,
    y1: 53.37,
    x2: 60.68,
    y2: 68.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.21,27.64c0-2.47,2-4.47,4.47-4.47s4.47,2,4.47,4.47-2,4.47-4.47,4.47-4.47-2-4.47-4.47Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "47.79 32.25 46.8 34.59 45.82 34.59"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "45.84 34.59 44.86 34.59 43.88 32.25"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "44.86 34.59 43.7 43.56 45.82 45.58 45.82 45.58 47.96 43.56 46.8 34.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.5df43c0c462b4bbd02879623ec6360dc.svg";
export { ForwardRef as ReactComponent };